import { useRequest } from 'alova';
import { alovaScoreInstance } from './alovaScoreInstance';
import { alovaInstanceAuth } from '@admission/apis/auth/alovaInstanceOnboarding';
import { IScoreApiResponse, Notification, CpfReport } from '@tally/types';

export const useApiScore = () => {
  const notificationRequest = useRequest(alovaScoreInstance.Get<IScoreApiResponse<Notification[]>>('/v1/notification'), { immediate: false });

  const notificationMarkAsRead = useRequest((payload) => alovaScoreInstance.Patch<IScoreApiResponse<Notification[]>>('/v1/notification', payload), {
    immediate: false,
  });

  const notificationDelete = useRequest((payload) => alovaScoreInstance.Delete<IScoreApiResponse<Notification>>('/v1/notification', payload), {
    immediate: false,
  });

  // Relatório de CPF migrado para a identity-api (POST /v2/app/customer/report).
  // O CPF é resolvido no backend a partir do token, então não há payload.
  const CpfReport = useRequest(() => alovaInstanceAuth.Post<CpfReport>('/v2/app/customer/report'), {
    immediate: false,
  });

  return {
    notificationRequest,
    notificationMarkAsRead,
    notificationDelete,
    CpfReport,
  };
};
